import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Trophy, Flame } from "lucide-react";

const LEVEL_CLS = { Bronze: "level-bronze", Silver: "level-silver", Gold: "level-gold", "Certified Pro": "level-pro" };

export default function Rewards() {
  const [lb, setLb] = useState([]);
  const [ledger, setLedger] = useState([]);

  useEffect(() => {
    api.get("/rewards/leaderboard").then((r) => setLb(r.data));
    api.get("/rewards/ledger").then((r) => setLedger(r.data));
  }, []);

  return (
    <div className="p-8 space-y-6" data-testid="rewards-page">
      <header>
        <div className="overline">// rewards · engine</div>
        <h1 className="font-display font-black text-3xl mt-1">Rewards & Leaderboard</h1>
        <p className="text-zinc-500 text-sm mt-1">Job card +2 · Lesson +5 · Referral +10 · Levels: Bronze → Silver → Gold → Certified Pro.</p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-3">
        {/* Leaderboard */}
        <div className="gs-card p-5">
          <div className="overline mb-3 flex items-center gap-2"><Trophy className="w-3.5 h-3.5 text-amber-500" /> Leaderboard</div>
          <div className="space-y-2">
            {lb.map((m, i) => (
              <Link to={`/mechanics/${m.id}`} key={m.id}
                data-testid={`leaderboard-row-${i}`}
                className="flex items-center gap-3 p-2 hover:bg-zinc-900/40 border-b border-zinc-900">
                <div className="font-mono-data text-xs text-zinc-600 w-6 text-right">#{i + 1}</div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-zinc-100">{m.name}</div>
                  <div className="text-[11px] text-zinc-600 font-mono-data">{m.city} · {m.repairs_completed} repairs</div>
                </div>
                <div className="text-right">
                  <div className="font-mono-data text-amber-500 font-bold">{m.points}</div>
                  <span className={`px-1.5 py-0.5 text-[9px] font-display font-bold border ${LEVEL_CLS[m.skill_level]}`}>{m.skill_level.toUpperCase()}</span>
                </div>
                <div className="flex items-center gap-1 text-xs text-zinc-400">
                  <Flame className="w-3 h-3 text-amber-500" />{m.learning_streak}
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Points ledger */}
        <div className="gs-card p-5">
          <div className="overline mb-3">Points Ledger</div>
          <div className="space-y-1.5 max-h-[480px] overflow-y-auto">
            {ledger.map((r) => (
              <div key={r.id} className="flex items-center justify-between border-b border-zinc-900 py-1.5 text-xs">
                <div className="min-w-0">
                  <div className="text-zinc-200 truncate">{r.mechanic_name}</div>
                  <div className="text-zinc-600 font-mono-data">
                    {r.reason} {r.meta ? `· ${r.meta}` : ""}
                  </div>
                </div>
                <div className="font-mono-data font-bold text-amber-500">+{r.points}</div>
              </div>
            ))}
            {ledger.length === 0 && <div className="text-zinc-600 text-sm">No rewards yet.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
